export enum DocumentType {
  PAYIN = "PAYIN",
  WITHHOLD = "WITHHOLD",
  OTHER = "OTHER"
}

export enum DocumentTypeLabel {
  PAYIN = "Pay-in Slip/Statement",
  WITHHOLD = "Withholding Tax",
  OTHER = "Others"
}

export enum PaymentMethod {
  BANK_TRANSFER = "BANK_TRANSFER",
  CREDIT_CARD = "CREDIT_CARD"
}

export enum PaymentMethodLabel {
  BANK_TRANSFER = "Bank Transfer",
  CREDIT_CARD = "Credit Card"
}

export enum FeeType {
  BAHT = "BAHT",
  PERCENT = "PERCENT"
}

export enum FeeTypeLabel {
  BAHT = "THB",
  PERCENT = "%"
}

export interface IDocumentFile {
  id?: string;
  file: File;
  documentType: DocumentType;
  paymentMethod?: PaymentMethod;
}

export interface ICashsaleFormValues {
  orderAmount: number | string;
  arAmount: number;
  cashFlag: boolean;
  cashAmount: number | string;
  balanceFlag: boolean;
  balanceAmount: number | string;
  customerPaymentDifference: number;
  fee: number | string;
  feeType: FeeType;
  feeAbsorbFlag: boolean;
  withHoldTax: number | string;
  remark: string;
  documentFiles: IDocumentFile[];
}
